import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistAnswerCreateModel } from 'shared/domain/checklistAnswer/types/model';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistAnswerHttpCreateRequestModel } from '../httpQueue/checklistAnswer/types';

export class ChecklistAnswerSaver {
  constructor(
    private addRequest: (
      request: ChecklistAnswerHttpCreateRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    createModel: ChecklistAnswerCreateModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('AddChecklistAnswerUseCase', createModel);

    const url = `/project/${createModel.projectId}/inspectionTemplate/${createModel.inspectionTemplateId}/checklistItem/${createModel.checklistItemId}/checklistAnswer`;

    const request: ChecklistAnswerHttpCreateRequestModel = {
      createdAt: Date.now(),
      method: 'POST',
      data: {
        checklistAnswerOutDto: createModel.answer,
        projectId: createModel.projectId,
        inspectionTemplateId: createModel.inspectionTemplateId,
        checklistItemId: createModel.checklistItemId,
        uniqueId: uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistAnswer,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistAnswerSaver = new ChecklistAnswerSaver(addRequest);
